import { HashRouter, Routes, Route, Navigate } from "react-router-dom";
import styled, { ThemeProvider, createGlobalStyle } from "styled-components";

import { theme } from "./theme.ts";

import { IdentifyScreen } from "./screens/IdentifyScreen.tsx";
import { ReviewScreen } from "./screens/ReviewScreen.tsx";
import { ExportScreen } from "./screens/ExportScreen.tsx";
import { MeetingsScreen } from "./screens/MeetingsScreen.tsx";
import { NewMeetingScreen } from "./screens/NewMeetingScreen.tsx";
import { ViewerScreen } from "./screens/ViewerScreen.tsx";
import { AdminScreen } from "./screens/AdminScreen.tsx";
import { CorrectionsScreen } from "./screens/CorrectionsScreen.tsx";
import { StructureScreen } from "./screens/StructureScreen.tsx";
import { ReportScreen } from "./screens/ReportScreen.tsx";
import { ReviewReportScreen } from "./screens/ReviewReportScreen.tsx";

const GlobalStyle = createGlobalStyle`
  * {
    box-sizing: border-box;
  }
  html, body {
    margin: 0;
    padding: 0;
    background: ${({ theme }) => theme.color.background};
    color: ${({ theme }) => theme.color.textPrimary};
    font-family: ${({ theme }) => theme.font.family};
    font-size: ${({ theme }) => theme.font.size.md};
    line-height: 1.5;
    -webkit-font-smoothing: antialiased;
  }
  button {
    font-family: inherit;
  }
`;

export function App() {
  return (
    <HashRouter>
      <ThemeProvider theme={theme}>
        <GlobalStyle />
        <Layout>
          <Routes>
            <Route path="/" element={<MeetingsScreen />} />
            <Route path="/meetings" element={<MeetingsScreen />} />
            <Route path="/new-meeting" element={<NewMeetingScreen />} />
            <Route path="/new-meeting/:processingId" element={<NewMeetingScreen />} />
            <Route path="/identify/:processingId" element={<IdentifyScreen />} />
            <Route path="/review/:processingId" element={<ReviewScreen />} />
            <Route path="/export/:processingId" element={<ExportScreen />} />
            <Route path="/viewer/:processingId" element={<ViewerScreen />} />
            <Route path="/viewer/:processingId/:srtFile" element={<ViewerScreen />} />
            <Route path="/corrections/:processingId" element={<CorrectionsScreen />} />
            <Route path="/structure/:processingId" element={<StructureScreen />} />
            <Route path="/structure/:processingId/:tab" element={<StructureScreen />} />
            <Route path="/report/:processingId" element={<ReportScreen />} />
            <Route path="/review-report/:processingId" element={<ReviewReportScreen />} />
            <Route path="/admin" element={<AdminScreen />} />
            <Route path="/admin/:tab" element={<AdminScreen />} />
            <Route path="*" element={<Navigate to="/meetings" replace />} />
          </Routes>
        </Layout>
      </ThemeProvider>
    </HashRouter>
  );
}

const Layout = styled.div`
  max-width: ${({ theme }) => theme.layout.maxWidth};
  margin: 0 auto;
  padding: ${({ theme }) => theme.space.xl} ${({ theme }) => theme.space.lg};
`;
